import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { describeInteractiveView } from "./describe-interactive-view";

export const interactiveViewToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [
    HOST_TOOL_NAMES.SHOW_INTERACTIVE_VIEW,
    describeInteractiveView({
      running: "Showing",
      done: "Showed",
      failed: "Failed to show",
    }),
  ],
  [
    HOST_TOOL_NAMES.PREVIEW_INTERACTIVE_VIEW,
    describeInteractiveView({
      running: "Previewing",
      done: "Previewed",
      failed: "Failed to preview",
    }),
  ],
];
